import { render, staticRenderFns } from "./MultiSelectPacker.vue?vue&type=template&id=b8cc6ec0&"
import script from "./MultiSelectPacker.vue?vue&type=script&lang=js&"
export * from "./MultiSelectPacker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports